export const state = {
  tree: null,
  myProducts: null,
  settings: null
};

export const actions = {
  initiate({ commit }, payload) {
    commit('setTree', payload.tree);
    commit('setMyProducts', payload.myProducts);
    commit('setSettings', payload.settings);
  }
};

export const mutations = {
  setMyProducts(state, payload) {
    state.myProducts = payload;
  },
  setSettings(state, payload) {
    state.settings = payload;
  },
  setTree(state, payload) {
    state.tree = payload;
  }
};

export const getters = {
  data(state) {
    if (!state.tree) {
      return;
    }

    const filteredProducts = state.tree.children.filter(
      (product) =>
        state.myProducts.filter((myProduct) => myProduct.policyTypeId === product.policyTypeId)
          .length !== 0
    );

    const data = {
      id: state.tree.id,
      title: state.tree.title,
      children: filteredProducts
    };

    return data;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
